import WebIM from "../libs/webIM/WebIM";
const mutationsTypes = {
	SHOW_MULTIANMODAL: "SHOW_MULTIANMODAL",
  HIDE_MULTIANMODAL: "HIDE_MULTIANMODAL",
  SET_CONFR: "SET_CONFR",
	SET_AVMEMBERMODAL_VISIBLE: "SET_AVMEMBERMODAL_VISIBLE",
	SET_EXPERT_STATUS: "SET_EXPERT_STATUS",
};

export default {
  state: {
    msgStatus: {},
    multiAVModalVisible: false,
    confr: {},
		addAVMemberModalVisible: false,
		expertStatus: null,
		// accountName: localStorage.getItem('accountName') && JSON.parse(localStorage.getItem('accountName')) || null
  },
  mutations: {
    [mutationsTypes.SHOW_MULTIANMODAL](state){
			state.multiAVModalVisible = true;
		},
		[mutationsTypes.HIDE_MULTIANMODAL](state){
			state.multiAVModalVisible = false;
    },
    [mutationsTypes.SET_CONFR](state, payload){
			state.confr = payload.confr;
		},
		[mutationsTypes.SET_AVMEMBERMODAL_VISIBLE](state, payload){
			state.addAVMemberModalVisible = payload.addAVMemberModalVisible;
		},
		[mutationsTypes.SET_EXPERT_STATUS](state, payload){
			state.expertStatus = payload.expertStatus;
		},
    updateMsgList(state, payload){
			// const { chatType, chatId, msg, bySelf, type, id } = payload;
			// state.msgList = Object.assign({}, state.msgList);
    },
    updateMessageMid(state, message){
      state.msgStatus = Object.assign({}, message);
    },
    updateMessageStatus(state, message){
			// const { id, mid, action, readUser } = message;
			
		},
		// SET_ACCOUNT_NAME (state, payload) {
    //   state.accountName = payload
    // }
  },
  actions: {
    showMultiAVModal(context){
			context.commit(mutationsTypes.SHOW_MULTIANMODAL);
		},
		hideMultiAVModal(context){
			context.commit(mutationsTypes.HIDE_MULTIANMODAL);
    },
    setConfr(context, payload){
			context.commit({
				type: mutationsTypes.SET_CONFR,
				confr: payload.confr
			});
		},
		setAVMemeberModalVisible(context, payload){
			context.commit({
				type: mutationsTypes.SET_AVMEMBERMODAL_VISIBLE,
				addAVMemberModalVisible: payload.addAVMemberModalVisible
			});
		},
		setExpertStatus(context, payload){
			context.commit({
				type: mutationsTypes.SET_EXPERT_STATUS,
				expertStatus: payload.expertStatus
			});
		},
  },
  getters: {

  }
}


// WEBPACK FOOTER //
// ./src/store/advisory.js